/* src/hooks/useVersionChecker.js */
import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import packageJson from '../../package.json';

export const useVersionChecker = () => {
  const [updateInfo, setUpdateInfo] = useState({
    needsUpdate: false,
    latestVersion: '',
    playStoreUrl: '',
    message: ''
  });

  const currentVersion = packageJson.version;

  useEffect(() => {
    // Escuchar el documento de configuración de la app en Firestore
    // Documento: configuracion_sistema/app_control
    const configRef = doc(db, 'configuracion_sistema', 'app_control');

    const unsubscribe = onSnapshot(configRef, async (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        const latestVersion = data.current_version;
        const playStoreUrl = data.play_store_url || '';
        const message = data.update_message || 'Hay una nueva versión disponible con mejoras importantes.';
        const forceUpdateEnabled = data.force_update_enabled ?? true;

        let localVersion = currentVersion;

        // Si estamos en un dispositivo nativo, intentar obtener la versión real del sistema
        if (Capacitor.isNativePlatform()) {
          try {
            const info = await App.getInfo();
            localVersion = info.version;
          } catch (e) {
            console.error('Error obteniendo versión de la app nativa:', e);
          }
        }

        // La actualización de Play Store solo tiene sentido en la plataforma móvil nativa (Capacitor)
        // En la web no se requiere actualización ya que el contenido se sirve actualizado al recargar.
        // Si force_update_enabled es false, se desactiva la comprobación para permitir pruebas en desarrollo.
        const needsUpdate = forceUpdateEnabled && Capacitor.isNativePlatform() && (localVersion !== latestVersion);

        setUpdateInfo({
          needsUpdate,
          latestVersion,
          playStoreUrl,
          message
        });
      }
    }, (error) => {
      console.error('Error al verificar versión de la app:', error);
    });

    return () => unsubscribe();
  }, [currentVersion]);

  return updateInfo;
};
